import { v4 as uuidv4 } from "uuid";
import { NetworkError } from "@/interfaces/errors/networkError";

const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL ?? "";
const BACKEND_URL_PRISME = process.env.NEXT_PUBLIC_PRISME_API_URL ?? "";

type PostRequestProps = {
  url: string;
  body: BodyInit | null | undefined;
  accessToken?: string;
  additionalHeaders?: { name: string; value: string }[];
  isPrisme?: boolean;
  contentTypeRequest?: string;
};

export const sendPostRequest = ({
  url,
  body,
  accessToken,
  additionalHeaders,
  isPrisme,
  contentTypeRequest,
}: PostRequestProps) => {
  if (url.includes(".js") || url.includes(".css") || url.includes(".html")) {
    return Promise.resolve({});
  }

  const requestHeaders: HeadersInit = new Headers();
  requestHeaders.append("x-request-id", uuidv4());

  if (contentTypeRequest !== undefined) {
    requestHeaders.append("Content-Type", contentTypeRequest);
  }

  if (!isPrisme) {
    requestHeaders.append(
      "x-api-key",
      process.env.NEXT_PUBLIC_BFF_API_KEY ?? ""
    );
  }

  additionalHeaders?.forEach((header) => {
    requestHeaders.append(header.name, header.value);
  });

  if (accessToken !== undefined) {
    requestHeaders.append("Authorization", `Bearer ${accessToken}`);
  }

  if (!requestHeaders.has("Accept")) {
    requestHeaders.append("Accept", "*/*");
  }

  return fetch(`${isPrisme ? BACKEND_URL_PRISME : BACKEND_URL}${url}`, {
    method: "POST",
    headers: requestHeaders,
    body: body,
  }).then(async (response) => {
    if (!response.ok) {
      throw new NetworkError(
        `Request returned error ${response.status}`,
        response.status
      );
    }

    const contentType = response.headers.get("content-type") ?? "";

    if (contentType.includes("application/json")) {
      return response.json();
    }

    if (
      contentType.includes("application/zip") ||
      contentType.includes("application/octet-stream") ||
      contentType.includes("application/pdf") ||
      contentType.includes("image/")
    ) {
      return response.blob();
    }

    return response.text();
  });
};
